import { Grid, TextField, Typography } from "@mui/material";
import ReadMoreReadLess from "../../app/common/ReadMoreReadLess";
import { AnswersProps } from "../../app/models/Answers";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";

const schema = yup.object().shape({
  policyChallenges: yup
    .string()
    .required("Must give an answer")
    .max(500, "Max characters reached"),
  policyAlign: yup
    .string()
    .required("Must give an answer")
    .max(500, "Max characters reached"),
  policyRequirements: yup
    .string()
    .required("Must give an answer")
    .max(500, "Max characters reached"),
  encountered: yup
    .string()
    .required("Must give an answer")
    .max(500, "Max characters reached"),
});

const StatementChildAbuse: React.FC<AnswersProps> = ({
  answersData,
  onAnswerChange,
}) => {
  const defaultValues = {
    policyChallenges: answersData.find((answer) => answer.systemCodeId === 25)
      ?.answer,
    policyAlign: answersData.find((answer) => answer.systemCodeId === 24)
      ?.answer,
    policyRequirements: answersData.find(
      (answer) => answer.systemCodeId === 279
    )?.answer,
    encountered: answersData.find((answer) => answer.systemCodeId === 3608)
      ?.answer,
  };

  const {
    register,
    formState: { errors },
  } = useForm({
    defaultValues,
    resolver: yupResolver(schema),
    mode: "onTouched",
  });

  const renderChildAbuseNeglectPolicyReflectionCompetence = () => {
    return (
      <>
        <li>What are the similarities? </li>
        <li>What are the differences?</li>
      </>
    );
  };

  return (
    <Grid container p={3} sx={{ bgcolor: "#EBFCF2" }}>
      <Grid item xs={12}>
        <Typography variant="body1" fontWeight={700} paragraph>
          CS I-c- Child Abuse and Neglect Policy Reflection
        </Typography>
      </Grid>
      <Grid item xs={12} mb={4}>
        <Typography variant="body1" paragraph>
          How does your Home Visitor program's policy align with state legal
          requirements?
        </Typography>
        <ReadMoreReadLess>
          <>{renderChildAbuseNeglectPolicyReflectionCompetence()}</>
        </ReadMoreReadLess>

        <TextField
          label="My home visitor program's policy aligns with state legal requirements in the following ways:"
          multiline
          rows={2}
          fullWidth
          {...register("policyAlign")}
          name="policyAlign"
          sx={{ bgcolor: "#FFF" }}
          value={
            answersData.find((answer) => answer.systemCodeId === 24)?.answer ||
            ""
          }
          onChange={(e) => {
            const newValue = e.target.value;
            const systemCodeId = 24;

            newValue.length <= 500 && onAnswerChange(systemCodeId, newValue);
          }}
          error={!!errors.policyAlign?.message}
          helperText={errors.policyAlign?.message}
        />
        <Typography fontSize={13}>
          {defaultValues.policyAlign?.length}/500
        </Typography>
      </Grid>
      <Grid item xs={12} mb={4}>
        <Typography>
          What do you consider as the strengths of this policy and what are the
          challenges?
        </Typography>

        <TextField
          label="My home visitor program's policy is challenging because"
          multiline
          rows={2}
          fullWidth
          {...register("policyChallenges")}
          name="policyChallenges"
          sx={{ bgcolor: "#FFF" }}
          value={
            answersData.find((answer) => answer.systemCodeId === 25)?.answer ||
            ""
          }
          onChange={(e) => {
            const newValue = e.target.value;
            const systemCodeId = 25;

            newValue.length <= 500 && onAnswerChange(systemCodeId, newValue);
          }}
          error={!!errors.policyChallenges?.message}
          helperText={errors.policyChallenges?.message}
        />
        <Typography fontSize={13}>
          {defaultValues.policyChallenges?.length}/500
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Typography>
          Have you ever encountered a situation that required your action and
          how did you or would you handle it?
        </Typography>
        <TextField
          value={
            answersData.find((answer) => answer.systemCodeId === 3608)
              ?.answer || ""
          }
          onChange={(e) => {
            const newValue = e.target.value;
            const systemCodeId = 3608;

            newValue.length <= 500 && onAnswerChange(systemCodeId, newValue);
          }}
          error={!!errors.encountered?.message}
          helperText={errors.encountered?.message}
          multiline
          rows={2}
          fullWidth
          sx={{ bgcolor: "#FFF" }}
        />
      </Grid>
    </Grid>
  );
};
export default StatementChildAbuse;
